<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("MESSAGES.show festival") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #405950">
        <i
          :class="$i18n.locale === 'en' ? 'fas fa-forward' : 'fas fa-backward'"
        ></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form>
        <div class="row">
          <div>
            <label style="color: #405950; font-size: 16px" class="mb-5">{{
              $t("MESSAGES.Festival image")
            }}</label>
          </div>
          <div class="image-wrapper">
            <div class="image-preview">
              <img loading="lazy" :src="data.media?.path" alt="photo" />
            </div>
          </div>

          <base-input
            col="6"
            type="text"
            :placeholder="$t('MESSAGES.Festival name arabic')"
            v-model.trim="data.nameAr"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('MESSAGES.Festival name english')"
            v-model.trim="data.nameEn"
            disabled
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descriptionAr')"
            v-model.trim="data.descProd"
            disabled
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descriptionEn')"
            v-model.trim="data.descProdEn"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('MESSAGES.festival provider name')"
            :value="data.festival_provider?.name"
            readonly
          />
          <base-input
            col="6"
            type="number"
            :placeholder="$t('MESSAGES.adultTicketPrice')"
            v-model.trim="data.price"
            readonly
          />
          <div class="input_wrapper switch_wrapper my-3 col-6">
            <v-switch
              color="green"
              :label="$t('MESSAGES.is_name_required')"
              v-model="data.is_name_required"
              disabled
              hide-details
            ></v-switch>
          </div>
          <div class="input_wrapper switch_wrapper my-3 col-6">
            <v-switch
              color="green"
              :label="$t('MESSAGES.children_pricing_enabled')"
              v-model="data.children_pricing_enabled"
              disabled
              hide-details
            ></v-switch>
          </div>
          <base-input
            v-if="data.children_pricing_enabled"
            col="4"
            type="number"
            :placeholder="$t('MESSAGES.min_age')"
            v-model.trim="data.min_age"
            readonly
          />
          <base-input
            v-if="data.children_pricing_enabled"
            col="4"
            type="number"
            :placeholder="$t('MESSAGES.max_age')"
            v-model.trim="data.max_age"
            readonly
          />
          <base-input
            v-if="data.children_pricing_enabled"
            col="4"
            type="number"
            :placeholder="$t('MESSAGES.child_price')"
            v-model.trim="data.child_price"
            readonly
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('MESSAGES.Festival type')"
            :value="data.type?.name"
            readonly
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('MESSAGES.ticketType')"
            :value="data.ticket_type?.name"
            readonly
          />
          <base-input
            v-if="data.type?.id === 'limited' || data.type?.id === 'extended'"
            col="6"
            type="date"
            :placeholder="$t('MESSAGES.Start date')"
            v-model.trim="data.festival_date"
            readonly
          />
          <base-input
            v-if="data.type?.id === 'extended'"
            col="6"
            type="date"
            :placeholder="$t('MESSAGES.End date')"
            v-model.trim="data.end_date"
            readonly
          />

          <festival-daily-schedule
            v-model="dailySchedules"
            :start-date="data.festival_date"
            :end-date="data.end_date"
            :festival-type="data.type"
            readonly
          />

          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('MESSAGES.terms of use arabic')"
            v-model.trim="data.usage_policy_ar"
            readonly
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('MESSAGES.terms of use english')"
            v-model.trim="data.usage_policy_en"
            readonly
          />
          <base-input
            col="12"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.address')"
            v-model.trim="data.address"
            readonly
          />

          <div class="col-12">
            <gmap-map
              :center="{
                lat: data.lat ?? 24.7136,
                lng: data.lng ?? 46.6753,
              }"
              :zoom="6"
              style="width: 100%; height: 300px"
            >
              <gmap-marker
                v-if="data.lat && data.lng"
                :position="{
                  lat: data.lat,
                  lng: data.lng,
                }"
              />
            </gmap-map>
          </div>

          <div class="col-12 my-4" v-if="purchasers.length">
            <button
              type="button"
              class="purchasers_toggle_btn"
              @click="showPurchasersTable = !showPurchasersTable"
            >
              <span>{{ $t("MESSAGES.festivalPurchasers") }}</span>
              <span class="purchasers_toggle_meta">
                ({{ purchasers.length }})
                <i
                  :class="
                    showPurchasersTable
                      ? 'fal fa-chevron-up'
                      : 'fal fa-chevron-down'
                  "
                ></i>
              </span>
            </button>
            <div v-show="showPurchasersTable" class="purchasers_table_wrapper">
              <table class="purchasers_table">
                <thead>
                  <tr>
                    <th>{{ $t("TABLES.Admins.serialNumber") }}</th>
                    <th>{{ $t("PLACEHOLDERS.name") }}</th>
                    <th>{{ $t("MESSAGES.ticketsCount") }}</th>
                    <th>{{ $t("MESSAGES.purchasedAt") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in purchasers"
                    :key="item.id || index"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>
                      <div class="purchaser_name_cell">
                        <img
                          v-if="item.avatar"
                          :src="item.avatar"
                          alt=""
                          class="purchaser_avatar"
                        />
                        <span>{{ item.name }}</span>
                      </div>
                    </td>
                    <td>{{ item.tickets_count }}</td>
                    <td dir="ltr">{{ item.purchased_at || "-" }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              disabled
              hide-details
            ></v-switch>
          </div>
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import FestivalDailySchedule from "@/components/festivals/FestivalDailySchedule.vue";
import {
  buildSchedulesFromApi,
  parseDateFromApi,
  resolveFestivalEndDate,
} from "@/utils/festivalSchedule";

export default {
  name: "ShowFestival",

  components: {
    FestivalDailySchedule,
  },

  data() {
    return {
      dailySchedules: [],
      purchasers: [],
      showPurchasersTable: false,
      data: {
        media: {
          path: null,
        },
        festival_provider: null,
        nameAr: null,
        nameEn: null,
        descProd: null,
        descProdEn: null,
        type: null,
        ticket_type: null,
        festival_date: null,
        end_date: null,
        usage_policy_ar: "",
        usage_policy_en: "",
        price: null,
        is_name_required: false,
        children_pricing_enabled: false,
        min_age: null,
        max_age: null,
        child_price: null,
        address: null,
        lat: null,
        lng: null,
        active: true,
      },
    };
  },

  computed: {
    festivalTypes() {
      return [
        { id: "extended", name: this.$t("MESSAGES.Extended") },
        { id: "limited", name: this.$t("MESSAGES.Limited") },
      ];
    },
    ticketTypes() {
      return [
        { id: "single", name: this.$t("MESSAGES.ticketTypeSingle") },
        { id: "multiple", name: this.$t("MESSAGES.ticketTypeMultiple") },
      ];
    },
  },

  methods: {
    mapPurchasers(purchasers) {
      return (purchasers || []).map((item) => ({
        id: item.user?.id || item.id,
        name: item.user?.name || item.name || "-",
        avatar: item.user?.avatar || item.avatar || null,
        tickets_count: item.tickets_count ?? 0,
        purchased_at: item.purchased_at || null,
      }));
    },

    async getStoreData() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: `festivals/${this.$route.params?.id}`,
        });

        const festival = res.data.data.Festival;

        this.data.nameAr = festival.name_ar;
        this.data.nameEn = festival.name_en;
        this.data.descProd = festival.description_ar;
        this.data.descProdEn = festival.description_en;
        this.data.media.path = festival.image;
        this.data.active = festival.is_active;
        this.data.festival_provider = festival.festival_provider;
        this.data.price = festival.price;
        this.data.is_name_required = !!festival.is_name_required;
        this.data.children_pricing_enabled = !!festival.children_pricing_enabled;
        this.data.min_age = festival.min_age;
        this.data.max_age = festival.max_age;
        this.data.child_price = festival.child_price;
        this.data.type = festival.type
          ? this.festivalTypes.find(
              (type) => type.id === festival.type.toLowerCase()
            )
          : null;

        const apiTicketType = festival.ticket_type;
        this.data.ticket_type = apiTicketType
          ? this.ticketTypes.find(
              (type) => type.id === String(apiTicketType).toLowerCase()
            )
          : null;

        this.data.festival_date = parseDateFromApi(festival.festival_date);
        this.data.end_date = resolveFestivalEndDate(
          festival.end_date,
          festival.time_slots || res.data.data.time_slots,
          this.data.type?.id
        );
        this.data.usage_policy_ar = festival.usage_policy_ar;
        this.data.usage_policy_en = festival.usage_policy_en;
        this.data.lat = festival.lat;
        this.data.lng = festival.lng;
        this.data.address = festival.address;
        this.purchasers = this.mapPurchasers(festival.purchasers);

        const festivalType = this.data.type?.id;
        this.dailySchedules = buildSchedulesFromApi(
          this.data.festival_date,
          this.data.end_date,
          festivalType,
          festival.time_slots || res.data.data.time_slots,
          festival.excluded_dates || res.data.data.excluded_dates,
          {
            start_time: festival.start_time,
            end_time: festival.end_time,
            max_tickets_count: festival.max_tickets_count,
          }
        );
      } catch (error) {
        console.log(error.response?.data?.message);
      }
    },
  },

  created() {
    this.getStoreData();
  },
};
</script>

<style>
.image-wrapper {
  max-width: 100%;
  overflow-x: auto;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-start;
  align-items: center;
  margin-top: 10px;
  white-space: nowrap;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding-inline: 10px;
}

.image-wrapper .image-preview {
  position: relative;
  transition: all 1s ease;
  overflow: hidden;
}

.image-wrapper img {
  border-radius: 8px;
  max-width: 400px;
  max-height: 400px;
}

.purchasers_toggle_btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 0.75rem;
  padding: 0.85rem 1rem;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #f7f7f7;
  color: #405950;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease;
}

.purchasers_toggle_btn:hover {
  background: #f0f0f0;
  border-color: #405950;
}

.purchasers_toggle_meta {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
}

.purchasers_table_wrapper {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  max-height: 280px;
  overflow-x: auto;
  overflow-y: auto;
}

.purchasers_table {
  width: 100%;
  border-collapse: collapse;
  min-width: 520px;
}

.purchasers_table th,
.purchasers_table td {
  padding: 12px 16px;
  text-align: center;
  border-bottom: 1px solid #f0f0f0;
  color: #405950;
  vertical-align: middle;
}

.purchasers_table thead th {
  position: sticky;
  top: 0;
  background: #f7f7f7;
  font-weight: 700;
  z-index: 1;
}

.purchasers_table tbody tr:last-child td {
  border-bottom: none;
}

.purchaser_name_cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.purchaser_avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}
</style>
